export const tableHeader = [
  {
    id: 'username',
    type: 'text',
    value: 'Usuário',
  },
  {
    id: 'code',
    type: 'text',
    value: 'Código',
  },
  {
    id: 'action',
    type: 'actions',
    value: '',
  },
]
